import { d as getDefaultExportFromNamespaceIfNotNamed } from './_commonjsHelpers-64249c85.js';

var process = {};

var _nodeResolve_empty = /*#__PURE__*/Object.freeze({
	__proto__: null,
	'default': process
});

var require$$4 = /*@__PURE__*/getDefaultExportFromNamespaceIfNotNamed(_nodeResolve_empty);

export { process as p, require$$4 as r };
